export const APP_NAME = 'cotizador';
